import React, { useMemo } from "react";

export default function BoardPagination({
  page = 1,
  pageSize = 15,
  total = 0,
  onPageChange,
  className = "",
  btnClassName = "",
  labelClassName = "",
}) {
  const totalPages = useMemo(() => {
    const t = Math.max(0, Number(total) || 0);
    const p = Math.max(1, Number(pageSize) || 1);
    const pages = Math.ceil(t / p);
    return Math.max(1, pages);
  }, [total, pageSize]);

  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div
      className={[
        "mt-3 flex items-center justify-center gap-2 text-sm",
        className,
      ].join(" ")}
    >
      <button
        className={[
          "rounded-lg border px-3 py-2 text-xs whitespace-nowrap hover:bg-gray-50 disabled:opacity-50",
          btnClassName,
        ].join(" ")}
        disabled={!canPrev}
        onClick={() => onPageChange && onPageChange(page - 1)}
      >
        이전
      </button>
      <span
        className={[
          "text-gray-600 text-xs sm:text-sm whitespace-nowrap",
          labelClassName,
        ].join(" ")}
      >
        {page} / {totalPages} 페이지 {total ? `(총 ${total}건)` : ""}
      </span>
      <button
        className={[
          "rounded-lg border px-3 py-2 text-xs whitespace-nowrap hover:bg-gray-50 disabled:opacity-50",
          btnClassName,
        ].join(" ")}
        disabled={!canNext}
        onClick={() => onPageChange && onPageChange(page + 1)}
      >
        다음
      </button>
    </div>
  );
}
